import { crud } from '@think-internet/zeus-frontend-package'
import { Type, Payload, ReplacePayload } from '../types'

export const setLocal = (type: Type, payload: Payload, replace: ReplacePayload = true) => ({
  type,
  payload,
  operation: crud.Operations.GET,
  replace,
})
